export default __webpack_public_path__ + "static/media/safe-travels-mb.7a82475e.png";